import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetPageContext as GetPageContextQuery,
    GetPageContextVariables as GetPageContextVariables,
} from 'nutshell-graphql-types';

import {generateContextString} from '../../helpers';

import GET_PAGE_CONTEXT from '../queries/get-page-context.graphql';

export const useGetPageContext = (
    id?: string | null
): {
    context: string | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<GetPageContextQuery, GetPageContextVariables>(
        GET_PAGE_CONTEXT,
        {
            variables: {
                id: id || '',
            },
            skip: !id,
            fetchPolicy: 'no-cache',
        }
    );

    return {
        context: generateContextString(data),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
